<section class="section grey-900 country-video" *ngIf="videoData">
  <div class="circle-gradient">&nbsp;</div>
  <div class="section-container">
    <div class="about-hero-content-box">
      <h2 class="section-heading white align-l">{{ videoData?.title }}</h2>
      <div
        class="landing-hero-content white"
        [innerHtml]="videoData?.content | toHtml"
      ></div>
    </div>
    <div class="product-blog-video">
      <video
        width="100%"
        height="100%"
        #videoPlayer
        class="myvid"
        [src]="videoData?.image?.[0]?.fields?.file?.url"
        (play)="onPlay()"
        (pause)="onPause()"
        controls
        [poster]=""
      >
        <source
          [src]="videoData?.image?.[0]?.fields?.file?.url"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</section>
